import React from "react";
import { Mail, Send, ExternalLink } from "lucide-react";
import "./footer.css";

export default function Footer() {
  return (
    <footer className="app-footer">
      <div className="footer-inner">
        {/* Brand */}
        <div className="footer-brand">
          <div className="footer-logo">M</div>

          <div className="footer-brand-text">
            <div className="footer-title">Mulu Health PLC</div>

            <div className="footer-subtitle">
              AHC PHC Capacity Assessment Tool
            </div>
          </div>
        </div>

        {/* Description */}
        <div className="footer-description">
          Supporting evidence-based Primary Health Care capacity assessment and
          improvement.
        </div>

        {/* Contact */}
        <div className="footer-contact">
          <div className="footer-contact-title">Contact</div>

          <a
            href="https://mail.google.com/mail/?view=cm&fs=1&to=muluhealth@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-contact-link"
          >
            <Mail className="footer-contact-icon" size={14} />
            <span>muluhealth@gmail.com</span>
          </a>

          <a
            href="https://t.me/MuluhealthPlc"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-contact-link"
          >
            <Send className="footer-contact-icon" size={14} />
            <span>@MuluhealthPlc</span>
          </a>

          <a
            href="https://muluhealth.com"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-contact-link"
          >
            <ExternalLink className="footer-contact-icon" size={14} />
            <span>muluhealth.com</span>
          </a>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <span>Version 5.0</span>

        <span className="footer-bottom-divider">•</span>

        <span>© 2026 Mulu Health PLC</span>
      </div>
    </footer>
  );
}
